export default __webpack_public_path__ + "static/media/irrigation_timing_midday.90a69011.jpg";